import React from 'react';
import type { ElementRef, Ref, ReactNode } from 'react';

import { styled } from '@backyard-ui/styles';
import type { StitchesCSS } from '@backyard-ui/styles';

import styles from './Badge.styles';
export interface BadgeProps {
  /**
   *  The badge appearance.
   */
  appearance?:
    | 'critical'
    | 'info'
    | 'neutral'
    | 'primary'
    | 'secondary'
    | 'success'
    | 'tertiary'
    | 'warning';

  /**
   * The variant is used
   * to change the visual communication.
   */
  variant?: 'solid' | 'subtle';

  /**
   * Icon rendered on the left side of label
   */
  icon?: React.ReactNode;

  /**
   * Stitches `css` func
   */
  css?: StitchesCSS;

  /**
   * The ref to the HTML DOM element
   */
  ref?: Ref<HTMLDivElement>;

  /**
   * The children elements
   */
  children: ReactNode;
}

const BadgeEl = styled('div', styles);

const Badge = React.forwardRef<ElementRef<typeof BadgeEl>, BadgeProps>(
  (props, ref) => {
    const { children, icon, ...rest } = props;

    const hasIcon = Boolean(icon);

    return (
      <BadgeEl icon={hasIcon} ref={ref} {...rest}>
        {hasIcon && (
          <span className="Backyard-Badge-icon" data-testid="Badge-icon">
            {icon}
          </span>
        )}
        <span className="Backyard-Badge-inner">{children}</span>
      </BadgeEl>
    );
  }
);

Badge.displayName = 'Badge';

export default Badge;
